// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"5772f0d0","703":"7cb641b7"}[chunkId] + ".chunk.js";
};